import { render } from "./WithdrawSubmitted.vue?vue&type=template&id=dd8d1660&scoped=true&ts=true"
import script from "./WithdrawSubmitted.vue?vue&type=script&lang=ts"
export * from "./WithdrawSubmitted.vue?vue&type=script&lang=ts"

import "./WithdrawSubmitted.vue?vue&type=style&index=0&id=dd8d1660&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mahmoud\\Desktop\\Bugs\\Dubai Projects\\JC_2\\mongo-web\\website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd8d1660"]])

export default __exports__